import { createElement } from 'react';
import { Parser } from 'htmlparser2';
export const contentToAst = (content, componentBuilderList) => {
    const root = {
        constructor: 'article',
        props: {},
        children: [],
    };
    const stack = [root];
    const parser = new Parser({
        onopentag: (name, attr) => {
            const child = {
                constructor: () => null,
                props: {},
                children: [],
            };
            // custom components
            for (const builder of componentBuilderList) {
                const res = builder(name, attr);
                if (res) {
                    child.constructor = res.constructor;
                    child.props = res.props;
                    break;
                }
            }
            stack.at(-1)?.children?.push(child);
            stack.push(child);
        },
        ontext: (data) => {
            stack.at(-1)?.children?.push(data);
        },
        onclosetag: () => {
            stack.pop();
        },
    });
    parser.parseComplete(content);
    return root;
};
export const astToElement = (ast) => {
    if (ast.children.length === 0) {
        if (typeof ast.constructor === 'string') {
            return createElement(ast.constructor, ast.props);
        }
        return ast.constructor(ast.props);
    }
    const children = ast.children.map((child) => {
        return typeof child === 'string' ? child : astToElement(child);
    });
    if (typeof ast.constructor === 'string') {
        return createElement(ast.constructor, ast.props, ...children);
    }
    return ast.constructor({ ...ast.props, children });
};
